import { FetchStatus, IQuery, IQueryMultiple, QueryType } from "../../../base/types";

import { IFilterGroup } from "../../../data";
import { IOrderBy } from "../models";
import { useDataContext } from "./DataContextProvider";
import { useEffect } from "react";
import { useReadAttributes } from "../../../base/hooks";

interface IDataContextProps {
    produce?: "Record" | "RecordSet",
    newRecord?: boolean,
    entity?: string,
    fields: string[],
    systemId?: string,
    filters: IFilterGroup[],
    orderBy?: IOrderBy,
    pageSize?: number,
}

export const DataContextProducer = (props: IDataContextProps) => {
    const { produce, newRecord, entity, fields, systemId, filters, orderBy, pageSize } = props;
    const { readAttributes } = useReadAttributes();
    const { setData, dataSource, setDataSource, fetch } = useDataContext()

    useEffect(() => {
        if (!entity) {
            setData({ type: "Static", status: FetchStatus.Success })
            return;
        }

        readAttributes(entity)
            .then(attributes => setDataSource({ entity, attributes }))
        // eslint-disable-next-line
    }, [entity])

    useEffect(() => {
        if (!dataSource)
            return;

        switch (produce) {
            case "RecordSet":
                fetch({ queryType: QueryType.MultipleRecords, query: getReadMultipleQuery() });
                break;
            case "Record":
            default:
                if (newRecord === true) {
                    setData({ type: "Card", result: {}, status: FetchStatus.Success })
                } else {
                    loadCardData();
                }
                break;
        }

        // eslint-disable-next-line
    }, [dataSource, props])

    const getReadMultipleQuery = (): IQueryMultiple => {
        return { fields, filters, orderBy, pageSize }
    }

    const loadCardData = () => {
        if (systemId) {
            const query: IQuery = { id: systemId, fields }
            fetch({ queryType: QueryType.Record, query })
        } else {
            const query = getReadMultipleQuery()
            fetch({ queryType: QueryType.FirstRecord, query })
        }
    }

    return <></>
}